module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_0.9fe6db97.png";